import { NewDeal } from 'types'

export const initialDealState: NewDeal = {
  PK: '',
  SK: '',
  name: '',
  deal_uuid: '',
  originalName: '',
  dba: '',
  isDeal: true,
  organizations: [],
  type: '',
  description: '',
  stage: 'Discovery',
  status: 'Draft',
  probability: '',
  agreementOptions: '',
  agreementOption: '',
  invoiceOptions: '',
  invoiceOption: '',
  invoiceStatus: 'Not Invoiced',
  contacts: [],
  primaryContact: [],
  startDate: null,
  endDate: null,
  closeDate: null,
  recipients: {
    contactRecipient: [],
    authorizedRecipient: [],
  },
  targetLaunchDate: null,
  dependenciesDueDate: null,
  managementFee: '',
  grossProfit: '',
  setupFee: '',
  implementationFee: '',
  monthlyTotal: '',
  total: '',
  mediaSpend: '',
  createdBy: [],
  owner: [],
  noSignature: false,
  needsApproval: false,
  isRequested: false,
  isApproved: false,
  isInternal: false,
  isCompleted: false,
  isCreated: false,
  isDraft: true,
  dealStatus: 'In Progress',
  EntityType: 'deal',
  numberOfPayments: 2,
  lastModified: '',
  id: '',
  activeDays: 0,
  products: [],
  onboardingStatus: 'Staging',
  slaDays: '',
  estLaunchDate: '',
}
